export default __webpack_public_path__ + "static/media/beautiful-asia.fdf7e43c.svg";